/**
 * Freshness banner for valuation surfaces.
 *
 * Google weights recency heavily for market/index/price queries, so every card
 * valuation surface states, in visible text, which marketplaces the numbers come
 * from and exactly when they were last synced (real sync timestamp, never render
 * time).
 */
export function PriceFreshness({
  updated,
  className = "mt-6",
}: {
  updated?: string | null;
  className?: string;
}) {
  const stamp = updated
    ? new Date(updated).toLocaleString("en-US", { timeZone: "UTC", dateStyle: "medium", timeStyle: "short" }) + " UTC"
    : "the latest daily sync";
  return (
    <section className={`glass rounded-2xl p-4 ${className}`} aria-labelledby="price-freshness-heading">
      <h2 id="price-freshness-heading" className="text-sm font-bold sm:text-base">
        Live eBay &amp; TCGplayer prices and TCGplayer Last Sold — updated daily
      </h2>
      <p className="aeo-answer mt-1.5 text-xs leading-relaxed text-muted-foreground sm:text-sm">
        Every price on this page is rebuilt from validated marketplace listings twice a day, so no printing waits in a
        weekly refresh rotation. Last synced {stamp}.
      </p>
    </section>
  );
}
